/**
 * How a frame link is rendered under a basePath: an app link (relative to the
 * basePath, which Next adds back) when it stays inside the app, a plain anchor
 * when it leaves it. Without a basePath — in the host — every link is an app link.
 */
export function resolveFrameHref(basePath: string, href: string): { app: boolean; href: string } {
  if (basePath === '') return { app: true, href }
  if (href === basePath || href.startsWith(`${basePath}/`) || href.startsWith(`${basePath}?`)) {
    return { app: true, href: href.slice(basePath.length) || '/' }
  }
  return { app: false, href }
}
